import { render, staticRenderFns } from "./title-company.vue?vue&type=template&id=938195cc"
import script from "./title-company.vue?vue&type=script&lang=js"
export * from "./title-company.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports